common.View.create('canvas.blocks.custom.contact.Block', {

    onDOMLoad() {
        this.initRecaptchaSend();
    },

    initRecaptchaSend()
    {
        let $form = this.element.find('form');
        if( !$form.data('recaptchaSend') ) {
            return;
        }

        $form.find('[dusk="captcha"]').addClass('hidden');

        // Stop form submit to show recaptcha so we can have a form with 1 field and a submit button
        // and still make it look nice
        $form.on('submit', (event) => {
            if( !$form.find('[dusk="captcha"]').length || $form.find('[dusk="captcha"]').is(':visible') ) {
                return;
            }

            event.preventDefault();

            $form
                .find('[class*="crud::form-inputs"]:not([class*="Submit"])')
                    .fadeOut()
                    .end()
                .find('[dusk="captcha"]')
                    .fadeIn()
                    .end();

            this.element
                .find('.callMeAction')
                    .addClass('pb-1')
                    .end();

            return false;
        })
    }
});
